import { useMutation, useQuery } from 'react-query';
import { cancelMatch, getMatches } from './index';

export const useQueryGetMatches = (entity) =>
  useQuery('matches', async () => {
    const result = await getMatches(entity);
    const data = result?.data ?? [];
    return data;
  });

export const useMutationCancelMatch = () =>
  useMutation(async (matchId) => {
    await cancelMatch(matchId);
    return;
  });
